import React from 'react'

import { mergeDeep } from '@root/utility'

import { form as form_config } from '@Config/Forms/user'

export var list =
{
	model: 'user',
	title: 'Liste des membres de CE',
	link: '/gestion-des-CE/membres',
	creation_link: '/gestion-des-CE/nouveau-membre',
	creation_label: 'Créer un nouvel utilisateur',
	row_link_base: '/gestion-des-CE/membres/',

	header_map:
	{
		'Identifiant': 'login',
		'Prénom': 'firstname',
		'Nom': 'lastname',
		'Comité d\'Entreprise': 'EC',
		'Date de création': 'createdAt',
		'Date de validation': 'validation_date',
		'Rôle': 'permissions.title',
		'Statut': 'validation_status'
	},

	date_fields: ['Date de création', 'Date de validation'],

	searched_prop: ['login', 'firstname', 'lastname'],

	filter_query:
	{
		or:
		[
			{
				'permissions.title': 'Administrateur de CE'
			},
			{
				'permissions.title': 'Membre de CE'
			},
			{
				'permissions.title': 'Partenaire'
			}
		]
	},

	field_hook:
	{
		'Statut': function (value)
		{
			if (value === 'validated')
			{
				let output =
				(
					<div className="c-status-indicator c-status-indicator--green">
						<div className="c-status-indicator__circle"></div>
						Activé
					</div>
				);

				return output;
			}
			else if (value === 'pending')
			{
				let output =
				(
					<div className="c-status-indicator c-status-indicator--red">
						<div className="c-status-indicator__circle"></div>
						En attente
					</div>
				);

				return output;
			}
			else if (value === 'new')
			{
				let output =
				(
					<div className="c-status-indicator c-status-indicator--blue">
						<div className="c-status-indicator__circle"></div>
						Récupéré
					</div>
				);

				return output;
			}
			else if (value === 'imported')
			{
				let output =
				(
					<div className="c-status-indicator c-status-indicator--blue">
						<div className="c-status-indicator__circle"></div>
						Importé
					</div>
				);

				return output;
			}
			
			else if (value === 'disabled')
			{
				let output =
				(
					<div className="c-status-indicator">
						<div className="c-status-indicator__circle"></div>
						Désactivé
					</div>
				);

				return output;
			}
		}
	},

	sort: function (data)
	{
		data = data.sort(function (a, b)
		{
			if (a.validation_status === b.validation_status)
			{
				return 0;
			}

			if (a.validation_status === 'pending')
			{
				return -1;
			}

			if (a.validation_status === 'new' && b.validation_status === 'validated')
			{
				return -1;
			}

			if (a.validation_status === 'new' && b.validation_status === 'pending')
			{
				return 1;
			}

			if (a.validation_status === 'validated')
			{
				return 1;
			}
		});

		return data;
	}
};

var config = mergeDeep({ }, form_config);

mergeDeep(config, list);

export default config